import easingProgress from 'easing-progress';
/**
 * Easing progress
 */
const easing = easingProgress;
export default easing;
